
import React, {createRef} from 'react'
import {connect} from "react-redux";
import {servidor, servicioRestfulCompleto, servicioRestfulMinimo} from "../Configuracion";
import PropTypes from "prop-types";
import Titulo from "../../framework2/ej2/UI/Titulo";
import SignaturePad from 'signature_pad';
import ConsentimientoSeleccionTipo from "./ConsentimientoSeleccionTipo";
import ConsentimientoDatos from "./ConsentimientoDatos";
import ConsentimientoTexto from "./ConsentimientoTexto";
import ConsentimientoFirma from "./ConsentimientoFirma";
import {obtenerClinicaCodigo} from "../utils/WindowUtils";
import ClienteRestful from "../../framework2/ej2/network/ClienteRestful";
import {loadDatosServicio, postServicio} from "../utils/FormularioUtils";

const CONSENTIMIENTO_SHOW= 'CONSENTIMIENTO_SHOW';
const CONSENTIMIENTO_SELECCION_TIPO= 'CONSENTIMIENTO_SELECCION_TIPO';
const CONSENTIMIENTO_DATOS= 'CONSENTIMIENTO_SELECCION_DATOS';
const CONSENTIMIENTO_TEXTO= 'CONSENTIMIENTO_TEXTO';
const CONSENTIMIENTO_FIRMA= 'CONSENTIMIENTO_FIRMA';

class Consentimiento extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            cargandoDatos: false,
            estado: CONSENTIMIENTO_SELECCION_TIPO,

            consentimientotipoCodigo: 0,
            consentimientoTextoHTML: "",
            consentimientoTextoHTMLTransformado: "",
            fecha: "",
            lugar: "Alaquas",
            esMenorDeEdad: false,
            tutorNombre: "",
            tutorDni: "",
            firma64: "",
        }
    }

    componentDidMount() {
        let clinicaCodigo= obtenerClinicaCodigo();
        let lugar= "";
        switch (clinicaCodigo){
            case 1: lugar= "Alaquas"; break;
            case 2: lugar= "Massanassa"; break;
            default: break;
        }
        this.setState({lugar: lugar});
    }

    //------------------------------------------------------------------------------------------------------------------
    // ACCIONES
    //------------------------------------------------------------------------------------------------------------------

    guardar= () => {
        const {consentimientoTextoHTMLTransformado, consentimientotipoCodigo, fecha, lugar, esMenorDeEdad, tutorNombre, tutorDni, firma64} = this.state;
        const {paciente, onAceptar} = this.props;

        let newConsentimiento= {
            fecha: new Date(),
            pacienteCodigo: paciente,
            consentimientotipoCodigo: { codigo: consentimientotipoCodigo},
            esmenor: esMenorDeEdad,
            tutornombre: tutorNombre,
            tutoridfiscal: tutorDni,
            firma: firma64,
            texto:  consentimientoTextoHTMLTransformado,
        }

        let usuarioCodigo= 9999;
        let url= servidor + servicioRestfulMinimo + "Consentimiento/" + usuarioCodigo;
        const clienteRestful = new ClienteRestful().setUrl(url);
        console.log("url: ", url);
        clienteRestful.doPost(newConsentimiento, response => {
            let consentimiento= response;
            console.log("consentimiento: ", consentimiento);
            if (clienteRestful.exito && consentimiento) {
                //onGuardado && onGuardado(elementoCompleto);
                console.log("Guardado!");
                this.generarPdfa(consentimiento);

            }
        });

    }

    generarPdfa= (consentimiento) => {
        const { onAceptar} = this.props;

        let parametros= {
            codigo: consentimiento.codigo,
        }
        postServicio(this, "Consentimiento", "generarPdfA", parametros, () => {
            console.log("GENERAR PDFA FINALIZADO OK");
            onAceptar && onAceptar()
        });
    }

    onCancelar= () => {
        const {onCancelar} = this.props;
        //this.setState({estado: CONSENTIMIENTO_SELECCION_TIPO});
        onCancelar && onCancelar();
    }

    aceptarSeleccionTipo= (consentimientotipo) => {
        console.log("CONSENTIMIENTO ON ACEPTAR");
        console.log("consentimientotipo: ", consentimientotipo);
        this.setState({estado: CONSENTIMIENTO_DATOS, consentimientotipoCodigo: consentimientotipo.codigo, consentimientoTextoHTML: consentimientotipo.texto})
    }

    aceptarDatos= (datos) => {
        console.log("DATOS ON ACEPTAR");
        console.log("datos: ", datos);

        //Transformar texto con datos
        this.setState({estado: CONSENTIMIENTO_TEXTO, fecha: datos.fecha,
            esmenor: datos.esmenor, tutornombre: datos.tutornombre,  tutoridfiscal: datos.tutoridfiscal,
                consentimientoTextoHTMLTransformado: this.transformarTextoConDatos(datos) });
    }

    aceptarTexto= (datos) => {
        console.log("TEXTO ON ACEPTAR");
        this.setState({estado: CONSENTIMIENTO_FIRMA})
    }

    aceptarFirma= (datos64) => {
        const {onAceptar} = this.props;
        console.log("DATOS ON FIRMA");
        console.log("datos: ", datos64);
        this.setState({firma64: datos64}, this.guardar);
    }

    //------------------------------------------------------------------------------------------------------------------
    // Transformar texto
    //------------------------------------------------------------------------------------------------------------------

    transformarTextoConDatos= (datos) => {
        const{ consentimientoTextoHTML, lugar} = this.state;
        const{paciente} = this.props;

        console.log("transformarTextoConDatos");
        console.log("fecha: ", datos.fecha);

        let partes = consentimientoTextoHTML.split("[#"); // separamos por inicio de marcador
        let resultado = partes[0];      // primera parte antes del primer marcador

        for (let i = 1; i < partes.length; i++) {
            let sub = partes[i];
            let fin = sub.indexOf("#]");

            if (fin >= 0) {
                let clave = sub.substring(0, fin); // lo que está dentro del marcador
                let resto = sub.substring(fin + 2); // el texto que sigue después

                switch (clave){
                    case "LUGAR": resultado += "<b>" + lugar + "</b>" + resto; break;
                    case "FECHA": resultado += "<b>" + datos.fecha + "</b>"  + resto; break;
                    case "NOMBRE": resultado += "<b>" + paciente.nombre + "</b>"  + resto; break;
                    case "DNI": resultado += "<b>" + paciente.dni + "</b>" + resto; break;
                    case "TUTORNOMBRE":  resultado += ( datos.esMenorDeEdad ? "<b>" + datos.tutorNombre + "</b>" : "") + resto; break;
                    case "TUTORDNI":  resultado += ( datos.esMenorDeEdad ? "<b>" + datos.tutorDni + "</b>" : "") + resto; break;
                }
            } else {
                // si no hay cierre, lo dejamos tal cual
                resultado += "[#" + sub;
            }
        }
        return resultado;
    }

    //------------------------------------------------------------------------------------------------------------------
    // RENDER
    //------------------------------------------------------------------------------------------------------------------

    calcularTitulo= () => {
        const {estado} = this.state;

        switch (estado){
            case CONSENTIMIENTO_SELECCION_TIPO: return "1. Selección de tipo";
            case CONSENTIMIENTO_DATOS: return "2. Datos del firmante";
            case CONSENTIMIENTO_TEXTO: return "3. Texto";
            case CONSENTIMIENTO_FIRMA: return "4. Firma";
            default: return "";
        }
    }

    render() {
        const {estado, consentimientoTextoHTML, consentimientoTextoHTMLTransformado} = this.state;
        const {paciente} = this.props;
        let titulo= this.calcularTitulo();
        return (
            <div style={{margin: 8, padding: 4}}>
                <Titulo titulo={titulo} soloTitulo={true}/>
                {estado == CONSENTIMIENTO_SELECCION_TIPO &&
                    <ConsentimientoSeleccionTipo onAceptar={this.aceptarSeleccionTipo} onCancelar={this.onCancelar} /> }
                {estado == CONSENTIMIENTO_DATOS &&
                    <ConsentimientoDatos paciente={paciente} onAceptar={this.aceptarDatos} onCancelar={this.onCancelar} /> }
                {estado == CONSENTIMIENTO_TEXTO &&
                    <ConsentimientoTexto consentimientoTextoHTML={consentimientoTextoHTMLTransformado} onAceptar={this.aceptarTexto} onCancelar={this.onCancelar} /> }
                {estado == CONSENTIMIENTO_FIRMA &&
                    <ConsentimientoFirma paciente={paciente} onAceptar={this.aceptarFirma} onCancelar={this.onCancelar} /> }
            </div>
        )
    }

}

Consentimiento.propTypes = {
    paciente: PropTypes.object,
    consentimiento: PropTypes.object, //Para consultar uno que ya existe
    onAceptar: PropTypes.func,
    onCancelar: PropTypes.func,
}

const mapStateToProps = function(state) {
    return {
        auth: state.auth,
    }
}
export default connect(mapStateToProps)(Consentimiento);



